<template>
	<v-dialog v-model="dialog" width="500" persistent>
		<v-card>
			<v-card-title>
				<s-crud add edit @save="saveTaskUser($event)" height="auto" remove title="Usuarios"
					:filter="filterUser" :config="configSearch" searchInput close @close="dialog = false"
					ref="ScrudTaskUsers">
					<template scope="props">
						<v-row>
							<v-col cols="12" sm="12" md="12">
								<s-select-assigned :projectID="itemSelectedSave.TkpID" full return-object
									label="Responsable" clearable v-model="props.item.PrsID"></s-select-assigned>
							</v-col>
						</v-row>
					</template>
				</s-crud>
			</v-card-title>
		</v-card>
	</v-dialog>
</template>

<script>
import _sTaskUsersService from '@/services/InformationTechnology/TaskUsersService.js';
import sSelectAssigned from '@/components/Utils/SSelectAssigned.vue';

export default {
    name: 'TaskUsersModal',
    components: { sSelectAssigned },
    props: {
        value: { type: Boolean, default: false },
        itemSelectedSave: { type: Object, default: () => ({}) }
    },
    data() {
        return {
            filterUser: { TskID: 0 },
            configSearch: {
				model: {
					PrsID: "ID",
					NtpFullName: "NtpFullName"
				},
				service: _sTaskUsersService,
				headers: [
					{ text: "ID", value: "PrsID" },
					{ text: "Apellidos y Nombres", value: "NtpFullName" }
				]
			}
        };
    },
    computed: {
        dialog: {
            get() { return this.value; },
            set(val) { this.$emit('input', val); }
        }
    },
    watch: {
        dialog(val) {
            if (val && this.itemSelectedSave) {
                this.filterUser.TskID = this.itemSelectedSave.TskID;
                if(this.$refs.ScrudTaskUsers) {
                    setTimeout(() => {
                        this.$refs.ScrudTaskUsers.refresh();
                    }, 50);
                }
            }
        }
    },
    methods: {
        saveTaskUser(item) {
			item.TskID = this.itemSelectedSave.TskID;
			item.UsrCreateID = this.$fun.getUserID();
			item.UsrUpdateID = this.$fun.getUserID();
			this.$fun.alert("Seguro de Guardar?", "question")
				.then(r => {
					if (r.value) {
						_sTaskUsersService.save(item, this.$fun.getUserID())
							.then(resp => {
								if (resp && resp.status == 200) {
									this.$fun.alert("Se agrego correctamente", "success");
									this.$refs.ScrudTaskUsers.refresh();
								}
							});
					}
				});
		}
    }
};
</script>
